import { environment } from 'src/environments/environment';
import { LayoutInfo } from '../models/model/concretes/components/layout-info.model';
import { Step } from '../models/model/concretes/components/step.model';
import { GroupStep } from '../models/model/concretes/components/group-step.model';
import { Subscription } from '../models/model/concretes/shared/subcription.model';
import { isPartner } from './brand-utils';

export function createPJSubscription(hasAvenants: boolean): Subscription {
  return new Subscription([
    new GroupStep([
      new Step(
        new LayoutInfo(1, 'Connaissance adhérent et date de couverture', 'Informations'),
        'information',
        true,
        false,
        false
      ),
      new Step(
        new LayoutInfo(1, 'Connaissance adhérent et date de couverture', 'Souscripteur'),
        'subscriber',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(2, 'Offre et création du devis', 'Notre tarif'),
        'offer-customize',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(2, 'Offre et création du devis', 'Confirmation'),
        'quote-confirmation',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(3, 'Mise en place du prélèvement et création du contrat', 'Prélèvement'),
        'direct-debit',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(3, 'Mise en place du prélèvement et création du contrat', isPartner(environment) ? 'Accompagnement du client' : 'Questions additionnelles'),
        'cross-selling-c',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(
          4,
          'Signature des documents',
          hasAvenants ? 'Mise en place de votre avenant' : 'Vos documents contractuels'
        ),
        'special-conditions',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(4, 'Signature des documents', 'Confirmation'),
        'confirmation',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(4, 'Signature des documents', 'Questions additionnelles'),
        'cross-selling-w',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(4, 'Signature des documents', 'Validation du contrat'),
        'contract-validation',
        false,
        false,
        true
      )
    ])
  ]);
}

export function getPJStepPaths(hasAvenants: boolean): ReadonlySet<string> {
  return new Set(createPJSubscription(hasAvenants).groupSteps.flatMap(group => group.steps.map(step => step.url)));
}
